<template>
  <Modal
    title="Merge Accounts"
    submit-btn-text="Merge"
    @hide-modal="$emit('hide-modal')"
    @submit="handleSubmit"
  >
    <div class="flex flex-col gap-4 md:flex-row">
      <CustomerLookup
        v-model="destinationId"
        :filter-id="duplicateId"
        name="Account to keep"
        class="full-width"
        type="destination"
        data-cy="account-to-keep"
      />
      <i class="fa fa-exchange mx-4 hidden md:block" @click="handleSwap" />
      <CustomerLookup
        v-model="duplicateId"
        :filter-id="destinationId"
        name="Account to merge"
        class="full-width"
        type="duplicate"
        data-cy="account-to-merge"
      />
    </div>
  </Modal>
</template>

<script>
import { mapActions } from "vuex";

import Modal from "@/components/Modal.vue";
import useVuelidate from "@vuelidate/core";
import CustomerLookup from "./CustomerLookup.vue";

export default {
  components: {
    CustomerLookup,
    Modal
  },
  emits: ["hide-modal"],
  setup() {
    return {
      v$: useVuelidate()
    };
  },
  data() {
    return {
      destinationId: null,
      duplicateId: null
    };
  },
  beforeUnmount() {
    this.clearMergeAccounts();
  },
  methods: {
    ...mapActions([
      "mergeAccounts",
      "confirmDelete",
      "swapMergeAccounts",
      "clearMergeAccounts"
    ]),
    handleSwap() {
      this.swapMergeAccounts().then((mergeAccounts) => {
        this.destinationId = mergeAccounts.destination.customer.id;
        this.duplicateId = mergeAccounts.duplicate.customer.id;
      });
    },
    handleSubmit() {
      this.v$.$validate().then((valid) => {
        if (valid) {
          this.confirmDelete({
            message:
              "This merge cannot be undone. Are you sure you wish to continue?",
            title: "Confirm Merge",
            className: "merge-confirm-modal",
            confirmInputValue: "Merge"
          })
            .then(() => {
              this.mergeAccounts({
                data: {
                  destination_customer_id: this.destinationId,
                  duplicate_customer_ids: [this.duplicateId]
                }
              }).then(() => {
                window.notify.success("Accounts merged succesfully!");
                this.$emit("hide-modal");
                window.location.href = this.userShowPath(this.destinationId);
              });
            })
            .catch(() => {});
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.fa-exchange {
  cursor: pointer;
  margin-top: 30px;
}
</style>
